<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">{{ $t('reportorders.title') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div id="accordion">
            <div class="card mb-1">
              <div class="card-header" id="headingOne">
                <h4 class="mb-0">
                  {{ $t('reportorders.search-form') }}
                  <a
                    class="text-inherit"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                    href=""
                  >
                    <i class="icon-arrow-down"></i>
                  </a>
                </h4>
              </div>
              <div class="collapse show" id="collapseOne" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body border-top">

                  <div class="row">
                    <div class="col-12">
                      <div class="form-row align-items-center">
                        <div class="col-auto">
                          <label class="sr-only" for="filter_name">{{ $t('reportorders.supplier') }}</label>
                          <input
                            class="form-control mb-2"
                            id="filter_name"
                            type="text"
                            :placeholder="$t('reportorders.supplier')"
                            v-model="filter_name"
                          >
                        </div>
                        <div class="col-auto">
                          <label class="sr-only" for="filter_registration_code">{{ $t('reportorders.supplier-reg-code') }}</label>
                          <input
                            class="form-control mb-2"
                            id="filter_registration_code"
                            type="text"
                            :placeholder="$t('reportorders.supplier-reg-code')"
                            v-model="filter_registration_code"
                          >
                        </div>
                        <div class="col-auto">
                          <label class="sr-only" for="filter_start">{{ $t('reportorders.tender-start') }}</label>
                          <datetime
                            :phrases="{ok: 'Continue', cancel: 'Exit'}"
                            :week-start="1"
                            auto
                            format="dd.MM.yyyy"
                            id="filter_start"
                            input-class="form-control mb-2"
                            :placeholder="$t('reportorders.tender-start')"
                            type="date"
                            value-zone="local"
                            v-model="filter_start"
                          ></datetime>
                        </div>
                        <div class="col-auto">
                          <label class="sr-only" for="filter_finish">{{ $t('reportorders.tender-finish') }}</label>
                          <datetime
                            :phrases="{ok: 'Continue', cancel: 'Exit'}"
                            :week-start="1"
                            auto
                            format="dd.MM.yyyy"
                            id="filter_finish"
                            input-class="form-control mb-2"
                            :placeholder="$t('reportorders.tender-finish')"
                            type="date"
                            value-zone="local"
                            v-model="filter_finish"
                          ></datetime>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="form-row align-items-center">
                        <datefilters ref="datefilters" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="form-row align-items-center">
                        <div class="col-auto">
                          <button class="btn btn-success mb-2" type="submit" @click="filter">{{ $t('reportorders.search') }}</button>
                          <button class="btn btn-outline-info mb-2" type="cancel" @click="clear_filters">{{ $t('reportorders.reset') }}</button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper table-responsive container-fluid dt-bootstrap4 no-footer">
                <datatablebuttons/>
                <search @make_search="make_search"/>
                <table class="table table-striped dataTable my-4 w-100" id="parts">
                  <thead>
                    <tr>
                      <th>
                        <div class="checkbox c-checkbox">
                          <label class="mb-0 p">
                            <input class="select-box" type="checkbox" v-model="selectAll">
                            <span class="fa fa-check"></span>
                          </label>
                        </div>
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'name',
                          'sorting_desc': ordering === '-name'}"
                        @click="order('name')">{{ $t('reportorders.company') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'tender_code',
                          'sorting_desc': ordering === '-tender_code'}"
                        @click="order('tender_code')">{{ $t('reportorders.tender') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'number_of_details',
                          'sorting_desc': ordering === '-number_of_details'}"
                        @click="order('number_of_details')">{{ $t('reportorders.number-of-details') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'sum_of_details',
                          'sorting_desc': ordering === '-sum_of_details'}"
                        @click="order('sum_of_details')">{{ $t('reportorders.sum-of-details') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="row.id" class="gradeX" v-for="row in rows">
                      <td>
                        <div class="checkbox c-checkbox">
                          <label class="mb-0">
                            <input :value="row.id" class="select-box" type="checkbox" v-model="selected">
                            <span class="fa fa-check"></span>
                          </label>
                        </div>
                      </td>
                      <td>{{ row.name }}</td>
                      <td>
                        <router-link
                          v-if="row.tender && row.tender_status==='DRAFT'"
                          :to="{name: 'tender_edit', params: {id: row.tender}}"
                          target="_blank">
                          {{ row.tender_code }}
                        </router-link>
                        <router-link
                          v-else-if="row.tender"
                          :to="{name: 'tender_view', params: {id: row.tender}}"
                          target="_blank">
                          {{ row.tender_code }}
                        </router-link>
                        <span v-else>{{ row.tender_code }}</span>
                      </td>
                      <td>{{ row.number_of_details }}</td>
                      <td>{{ Number(row.sum_of_details).toFixed(2) }}</td>
                    </tr>
                  </tbody>
                </table>
                <pagination
                  :page="page"
                  :pages="pages"
                  :count="count"
                  :from="(page - 1) * 50 + 1"
                  :to="(page - 1) * 50 + rows.length"
                  @paginate="paginate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import Datatablebuttons from '@/components/Datatablebuttons.vue'
import Datefilters from '@/components/Datefilters'
import { Datetime } from 'vue-datetime'
import Pagination from '@/components/Pagination.vue'
import Search from '@/components/Search.vue'
import XLSX from 'xlsx'
import app from '../main'

function calculateData(data) {
  let rowsData = []
  let rows = data

  rows.forEach(row => {
    rowsData.push({
      0: row.id,
      1: row.name,
      2: row.tender_code,
      3: row.number_of_details,
      4: row.sum_of_details
    })
  })
  return rowsData
}

const getData = (route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || 'code'
  const page = parseInt(route.query.page) || 1

  let stored_filters = JSON.parse(
      localStorage.getItem('etend.filters.' + route.name)
  ) || {}
  const filterName = route.query.filter_name
      || stored_filters.filter_name
  const filterRegistrationCode = route.query.filter_registration_code
      || stored_filters.filter_registration_code
  const filterStart = route.query.filter_start
      || stored_filters.filter_start
  const filterFinish = route.query.filter_finish
      || stored_filters.filter_finish
      || null
  let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
      || {}
  let page_size = route.query.page_size
      || stored_page_size[route.name]
      || process.env.DEFAULT_PAGE_SIZE

  api.get('/reports/orders/', {
    params: {
      search: search,
      ordering: ordering,
      page: page,
      page_size: page_size,
      filter_name: filterName,
      filter_registration_code: filterRegistrationCode,
      filter_start: filterStart,
      filter_finish: filterFinish
    }
  })
    .then(resp => {
      next({
        rows: resp.data.results,
        rowsData: calculateData(resp.data.results),
        search: search,
        ordering: ordering,
        pages: resp.data.pages,
        count: resp.data.count,
        page: page,
        page_size: page_size,
        filter_name: filterName,
        filter_registration_code: filterRegistrationCode,
        filter_start: filterStart,
        filter_finish: filterFinish
      })
    })
}

export default {
  components: {
    datatablebuttons: Datatablebuttons,
    datefilters: Datefilters,
    datetime: Datetime,
    pagination: Pagination,
    search: Search
  },
  data () {
    return {
      rows: [],
      rowsData: [],
      filter_name: null,
      filter_registration_code: null,
      filter_start: null,
      filter_finish: null,
      search: null,
      ordering: 'code',
      pages: null,
      page_size: null,
      count: null,
      page: null,
      selected: [],
      columns: [
        this.$i18n.t('reportorders.company'),
        this.$i18n.t('reportorders.tender'),
        this.$i18n.t('reportorders.number-of-details'),
        this.$i18n.t('reportorders.sum-of-details')
      ]
    }
  },
  mounted () {
    this.$parent.menu = 'reports'
    this.$parent.submenu = 'orders'
    this.$i18n.locale = this.$store.getters.language

    let stored_filters = JSON.parse(
        localStorage.getItem('etend.filters.' + this.$route.name)
    )
    if (stored_filters) {
      this.$refs.datefilters.selected = stored_filters.datefilters_selection
      this.filter_groups = stored_filters.filter_groups
    }
  },
  methods: {
    export_selected_rows() {
      let copyJson = []
      return Promise.all([
        api.get('/reports/orders/', {
          params: {
            ids: this.selected.join(','),
            page_size: 0,
            search: this.search,
            ordering: this.ordering,
            filter_registration_code: this.filter_registration_code,
            filter_name: this.filter_name,
            filter_start: this.filter_start,
            filter_finish: this.filter_finish
          }
        }).then(resp => {
          let rowsData = calculateData(resp.data)
          rowsData.forEach(row => {
            let rowJson = {}
            let i = 1
            this.columns.forEach(col => {
              rowJson[col] = row[i]
              i += 1
            })
            copyJson.push(rowJson)
          })
          let dataWS = XLSX.utils.json_to_sheet(copyJson)
          let wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS, 'data')
          XLSX.writeFile(wb, 'export.xlsx')
        })
      ])
    },
    export_all_rows() {
      let copyJson = []
      return Promise.all([
        api.get('/reports/orders/', {
          params: {
            page_size: 0,
            search: this.search,
            ordering: this.ordering,
            filter_registration_code: this.filter_registration_code,
            filter_name: this.filter_name,
            filter_start: this.filter_start,
            filter_finish: this.filter_finish
          }
        }).then(resp => {
          let rowsData = calculateData(resp.data)
          rowsData.forEach(row => {
            let rowJson = {}
            let i = 1
            this.columns.forEach(col => {
              rowJson[col] = row[i]
              i += 1
            })
            copyJson.push(rowJson)
          })
          let dataWS = XLSX.utils.json_to_sheet(copyJson)
          let wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS, 'data')
          XLSX.writeFile(wb, 'export.xlsx')
        })
      ])
    },
    order (o) {
      this.$router.push({
        query: {
          search: this.search,
          ordering: o === this.ordering ? '-' + o : o,
          page: 1,
          page_size: this.page_size,
          filter_name: this.filter_name,
          filter_registration_code: this.filter_registration_code,
          filter_start: this.filter_start,
          filter_finish: this.filter_finish
        }
      })
    },
    paginate (p) {
      this.$router.push({
        query: {
          page: p.page,
          page_size: p.page_size,
          search: this.search,
          ordering: this.ordering,
          filter_name: this.filter_name,
          filter_registration_code: this.filter_registration_code,
          filter_start: this.filter_start,
          filter_finish: this.filter_finish
        }
      })
    },
    make_search () {
      this.$parent.make_search(this.search, this.ordering)
    },
    filter () {
      let filters = {
        search: this.search,
        ordering: this.ordering,
        page: 1,
        filter_name: this.filter_name,
        filter_registration_code: this.filter_registration_code,
        filter_start: this.filter_start,
        filter_finish: this.filter_finish
      }
      this.$store.dispatch('setFilters', {
        datefilters_selection: this.$refs.datefilters.selected,
        name: this.$route.name,
        ...filters
      })

      app.$Progress.start()
      api.get('/reports/orders/?page_size=50', {
        params: {...filters, page_size: this.page_size}
      })
        .then(resp => {
          app.$Progress.finish()

          this.rows = resp.data.results
          this.rowsData = []
          this.rows.forEach(row => {
            this.rowsData.push({
              0: row.id,
              1: row.name,
              2: row.tender_code,
              3: row.number_of_details,
              4: row.sum_of_details
            })
          })
          this.pages = resp.data.pages
          this.count = resp.data.count
          this.page = 1
        })
      this.$router.push({
        query:{
          search: this.search,
          ordering: this.ordering,
          page: 1,
          page_size: this.page_size,
          filter_name: this.filter_name,
          filter_registration_code: this.filter_registration_code,
          filter_start: this.filter_start,
          filter_finish: this.filter_finish
        }
      })
    },
    clear_filters () {
      this.filter_name = null
      this.filter_registration_code = null
      this.filter_start = null
      this.filter_finish = null
      this.$refs.datefilters.selected = null
      this.$store.dispatch('clearFilters', this.$route.name)

      app.$Progress.start()
      api.get('/reports/orders/', {
        params: {
          search: this.search,
          ordering: this.ordering,
          page: 1,
          page_size: this.page_size,
          filter_name: this.filter_name,
          filter_registration_code: this.filter_registration_code,
          filter_start: this.filter_start,
          filter_finish: this.filter_finish
        }
      })
        .then(resp => {
          app.$Progress.finish()

          this.rows = resp.data.results
          this.rowsData = []
          this.rows.forEach(row => {
            this.rowsData.push({
              0: row.id,
              1: row.name,
              2: row.tender_code,
              3: row.number_of_details,
              4: row.sum_of_details
            })
          })
          this.pages = resp.data.pages
          this.count = resp.data.count
          this.page = 1
        })
      this.$router.push({name: 'report_orders'}).catch(() => {})
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    },
    selectAll: {
      get: function () {
        return this.rows ? this.selected.length === this.rows.length : false
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.rows.forEach(function (p) {
            selected.push(p.id)
          })
        }
        this.selected = selected
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Reportorders.vue